import Carousel from 'react-bootstrap/Carousel';
import React from 'react';
import { StyledButton, StyledCarousel, StyledSlideImage } from './styles';

function CarouselInformation() {
  return (
    <StyledCarousel
      fade
      prevIcon={<StyledButton>Anterior</StyledButton>}
      nextIcon={<StyledButton>Próximo</StyledButton>}
      interval={30000}
      indicators={false}
    >
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img1.jpg" alt="Fluxo da viagem - etapa 1" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img2.jpg" alt="Fluxo da viagem - etapa 2" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img3.jpg" alt="Fluxo da viagem - etapa 3" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img4.jpg" alt="Fluxo da viagem - etapa 4" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img5.jpg" alt="Fluxo da viagem - etapa 5" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img6.jpg" alt="Fluxo da viagem - etapa 6" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img7.jpg" alt="Fluxo da viagem - etapa 7" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img8.jpg" alt="Fluxo da viagem - etapa 8" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img9.jpg" alt="Fluxo da viagem - etapa 9" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img10.jpg" alt="Fluxo da viagem - etapa 10" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img11.jpg" alt="Fluxo da viagem - etapa 11" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel/img12.jpg" alt="Fluxo da viagem - etapa 12" />
      </Carousel.Item>
    </StyledCarousel>
  );
}

export default CarouselInformation;
